import { render, staticRenderFns } from "./Wp_tb_order_count_detail_model.vue?vue&type=template&id=176ad9ae&scoped=true&"
import script from "./Wp_tb_order_count_detail_model.vue?vue&type=script&lang=js&"
export * from "./Wp_tb_order_count_detail_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176ad9ae",
  null
  
)

export default component.exports